'use es6';

import PropTypes from 'prop-types';
import Raven from 'raven-js';
import { Component } from 'react';
import { connect } from 'react-redux';
import { getContentModelId } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getHasInpagePreviewUnexpectedlyUnloaded } from 'ContentEditorUI/redux/selectors/inpageSelectors';
import FloatingAlertStore from 'UIComponents/alert/FloatingAlertStore';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  contentModelId: getContentModelId(state),
  hasInpagePreviewUnexpectedlyUnloaded: getHasInpagePreviewUnexpectedlyUnloaded(state)
});
class ShowUnexpectedPreviewUnloadWarning extends Component {
  componentDidMount() {
    const {
      hasInpagePreviewUnexpectedlyUnloaded
    } = this.props;
    this.mounted = true;
    if (hasInpagePreviewUnexpectedlyUnloaded) {
      this.showWarningAndTrackOnDelay();
    }
  }
  componentDidUpdate(prevProps) {
    const {
      hasInpagePreviewUnexpectedlyUnloaded
    } = this.props;
    if (!prevProps.hasInpagePreviewUnexpectedlyUnloaded && hasInpagePreviewUnexpectedlyUnloaded) {
      this.showWarningAndTrackOnDelay();
    }
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  showWarningAndTrackOnDelay() {
    // Set a timeout so that if the customer is navigating away from the _parent app_ (which will
    // cause the iframe to unload), we never end up showing the warning or tracking (because then
    // the unload is expected)
    setTimeout(() => {
      if (this.mounted) {
        this.showWarning();
        this.trackWithRaven();
      }
    }, 1000);
  }
  showWarning() {
    console.error('It looks like the preview iframe unexpected redirected to another URL');
    FloatingAlertStore.addAlert({
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.errors.default-error.inpageUnexpectedRedirect.default.title"
      }),
      message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "app.errors.default-error.inpageUnexpectedRedirect.default.message_jsx",
        elements: {
          UILink
        }
      }),
      type: 'danger',
      sticky: true
    });
  }
  trackWithRaven() {
    const {
      contentModelId
    } = this.props;

    // Send a new page event to LogFetch for failed inpage assets (once per editor session)
    // Link to logfetch for convenience: https://private.hubteam.com/logfetch/search?serviceIds=ERRORS.PAGE_EVENTS&searchFilters=event_key:EQUAL:inpage-preview-unexpectedly-redirected&environment=prod&logType=CUSTOM_LOGFETCH_EVENT
    if (this.alreadyLoggedWithRavenOnce) {
      return;
    }
    this.alreadyLoggedWithRavenOnce = true;
    Raven.capturePageEvent('inpage-preview-unexpectedly-redirected', {
      extra: {
        contentModelId
      }
    });
  }
  render() {
    return null;
  }
}
ShowUnexpectedPreviewUnloadWarning.propTypes = {
  contentModelId: PropTypes.number.isRequired,
  hasInpagePreviewUnexpectedlyUnloaded: PropTypes.bool.isRequired
};
export default connect(mapStateToProps)(ShowUnexpectedPreviewUnloadWarning);